import { render, staticRenderFns } from "./presTableHead.vue?vue&type=template&id=517eab4f&scoped=true&"
import script from "./presTableHead.vue?vue&type=script&lang=js&"
export * from "./presTableHead.vue?vue&type=script&lang=js&"
import style0 from "./presTableHead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./presTableHead.vue?vue&type=style&index=1&id=517eab4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517eab4f",
  null
  
)

export default component.exports